
import LinksGrid from "../components/LinksGrid"


export default function Links(){
    return (
        <div className="main-body">
            <LinksGrid />
            
        </div>
    )
}